var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon1 = function SvgIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 125,
    viewBox: "0 0 128 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 59,
    fill: "black",
    stroke: "#E38BB6",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 81.3486H59.953",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0254 80.9631V54.75H42.0948V80.9631",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0234 80.9639V43.3906H58.1111V80.9639",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0391 63.2608V31H74.1085V58.316",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1112 58.9785C66.3369 58.9785 59.2227 66.1476 59.2227 74.9894C59.2227 83.8313 66.3369 91.0004 75.1112 91.0004C83.8855 91.0004 90.9998 83.8313 90.9998 74.9894C90.9998 66.1476 83.8855 58.9785 75.1112 58.9785Z",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1321 68.0049C79.9099 68.5196 69.7857 79.696 68.0527 81.3504",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1328 79.3651V68.0049H69.8594",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 63,
    r: 60,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeDasharray: "5 5"
  })));
};
export default SvgIcon1;